import { render, staticRenderFns } from "./water-dialog.vue?vue&type=template&id=1f6c28e4&scoped=true"
import script from "./water-dialog.vue?vue&type=script&lang=js"
export * from "./water-dialog.vue?vue&type=script&lang=js"
import style0 from "./water-dialog.vue?vue&type=style&index=0&id=1f6c28e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c28e4",
  null
  
)

export default component.exports